import {CollisionComponent, Component, Object3D, Shape} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Puzzle} from './puzzle.js';
import {PuzzleCamera} from './puzzle-camera.js';
import {quat, vec3} from 'gl-matrix';
import {Mathf} from '../utils/Mathf.js';
import {vibrateDevice} from '../utils/vibrateDevice.js';

const tempVec = vec3.create();
const tempVec2 = vec3.create();
const tempVec3 = vec3.create();
const tempQuat = quat.create();
const tempQuat2 = quat.create();

export class LaneHighlight extends Component {
    static TypeName = 'lane-highlight';

    @property.object({required: true})
    puzzleObject!: Object3D;

    puzzle!: Puzzle;

    private _puzzleCamera!: PuzzleCamera;
    private _targetColumn = 0;
    private _column = 0;
    private _row = 0;

    start() {
        this.puzzle = this.puzzleObject.getComponent(Puzzle);
    }

    update(dt: number) {
        if (!this.puzzle.gameInProgress) {
            // if the game is not in progress, don't do anything
            return;
        }

        if (this._puzzleCamera == null) {
            this._puzzleCamera = this.puzzle.mainCamera;
        }
        const targetColumn = this._puzzleCamera.findClosestLane();
        if (targetColumn != this._column) {
            this._column = targetColumn;
            this.puzzle.lanes[this._column].getRotationLocal(tempQuat);
            this.object.setRotationLocal(tempQuat);
            this.object.rotateAxisAngleDegLocal([0, 1, 0], 180);
            vibrateDevice(10);
        }
    }
}
